// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BoxStep__container___3sa8k{margin-bottom:15px;padding:25px 20px;border:2px solid #eae9e3;border-radius:8px}.BoxStep__title___3Y_oJ{font-size:20px;line-height:32px}.BoxStep__description___2UYLL{color:#6b6651;font-size:16px}.BoxStep__solution_title___WIkyK{margin:20px 0;color:#807c6c}.BoxStep__solution_description___ztcmj{margin-top:20px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"container": "BoxStep__container___3sa8k",
	"title": "BoxStep__title___3Y_oJ",
	"description": "BoxStep__description___2UYLL",
	"solution_title": "BoxStep__solution_title___WIkyK",
	"solution_description": "BoxStep__solution_description___ztcmj"
};
module.exports = ___CSS_LOADER_EXPORT___;
